<template>
  <div></div>
</template>

<script setup>
import { onMounted } from 'vue';

onMounted(() => {
  window.location.replace('https://akademiaimprowizacji.pl/kursy-improwizacji/');
});
</script>
